import { render } from "./MainViewContainer.vue?vue&type=template&id=464be83c"
import script from "./MainViewContainer.vue?vue&type=script&lang=js"
export * from "./MainViewContainer.vue?vue&type=script&lang=js"

import "./MainViewContainer.vue?vue&type=style&index=0&id=464be83c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__